module.exports = __webpack_public_path__ + "img/feedback.65a4b54e.webp";